import { isNil } from 'lodash';
import { CommercialRentComp, CommercialRentRollUnit, CommercialUses } from 'types/underwriting/income-approach';

export const calculateMonthlyRentSummary = (subjectUnits: CommercialRentRollUnit[], comps: CommercialRentComp[]) => {
  const subjectUnitsWithRent = subjectUnits.filter((unit) => unit.rent);
  const subjectUnitsMap = {
    min: Math.min(...subjectUnitsWithRent.map((unit) => unit.rent!)),
    max: Math.max(...subjectUnitsWithRent.map((unit) => unit.rent!)),
    average: subjectUnitsWithRent.reduce((sum, unit) => sum + unit.rent!, 0) / subjectUnitsWithRent.length,
  };

  const compsMap = {
    min: Math.min(...comps.map((comp) => comp.monthlyRent)),
    max: Math.max(...comps.map((comp) => comp.monthlyRent)),
    average: comps.reduce((sum, comp) => sum + comp.monthlyRent, 0) / comps.length,
  };

  return {
    subjectUnits: subjectUnitsMap,
    comps: compsMap,
  };
};

export const groupCompsByUse = (rentComps: CommercialRentComp[]) => {
  const groups: { [key in string]: { use: CommercialUses; comps: CommercialRentComp[] } } = {};
  rentComps.forEach((comp) => {
    groups[comp.use] = groups[comp.use]
      ? { use: groups[comp.use].use, comps: [...groups[comp.use].comps, comp] }
      : { use: comp.use, comps: [comp] };
  });
  return Object.values(groups).sort((previousGroup, nextGroup) => previousGroup.use.localeCompare(nextGroup.use));
};

export const getSubjectUnitGroups = (rentRoll: CommercialRentRollUnit[]) => {
  const groups: { [key in string]: { use: CommercialUses; units: CommercialRentRollUnit[] } } = {};
  rentRoll
    .filter((unit) => !isNil(unit.use))
    .forEach((unit) => {
      groups[unit.use!] = groups[unit.use!]
        ? { use: groups[unit.use!].use, units: [...groups[unit.use!].units, unit] }
        : { use: unit.use!, units: [unit] };
    });
  return Object.values(groups);
};
